import { useState } from "react";
import toggle from "./toggle";
import MenuItem from "./menu-item";

function VisitMenu(props) {
  const [isVisitMenu, toggleVisitMenu] = useState(false);
  const toggleFunction = () => {
    toggle(toggleVisitMenu, !isVisitMenu);
  };

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${
        props.cssClass || ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap -mx-2">
          <li className="w-full md:w-4/12 px-2">
            <ul className="mt-2">
              <li>
                <MenuItem
                  linkKey={"Campus Tours"}
                  linkUrl={"/visit"}
                  linkText={"Visit Rollins"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Explore all of our visit options and start finding your fit on America’s most beautiful campus."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Campus Tours"}
                  linkUrl={"/visit/campus-tours"}
                  linkText={"In-Person Campus Tours"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "There’s no better way to experience Rollins’ personalized learning environment than to visit our lakeside campus."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Virtual Experiences"}
                  linkUrl={"/visit/virtual-experiences"}
                  linkText={"Connect With Us Virtually"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Schedule a chat with a counselor or student, attend a virtual info session, or create a one-of-a-kind virtual itinerary."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul className="mt-2">
              <li className="py-2">
                <MenuItem
                  linkKey={"Explore Rollins on Your Own"}
                  linkUrl={"/visit/virtual-tour"}
                  linkText={"Explore Rollins on Your Own"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Our virtual tours and student-hosted videos give you the freedom to explore the Rollins experience at your own pace."
                  }
                />
              </li>

              <li className="py-2">
                <MenuItem
                  linkKey={"Plan Your Visit"}
                  linkUrl={"/visit/plan-your-visit"}
                  linkText={"Plan Your Visit"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "From maps and directions to tips on what to see and do, we’ll help you make the most of your time in Winter Park."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-2">
            <ul className="">
              <li className="p-4">
                <p className="tracking-tight font-bold text-blue-500 group-hover:underline leading-tight mb-2">
                  Virtual Tour
                </p>
                <p className="w-full shadow">
                  <a href="https://www.youvisit.com/tour/rollins">
                    {props.visibility ? (
                      <img
                        src={`https://cdn.sanity.io/images/qe2ul2l0/production/b6ef5717865863c3c104ee9dab2ff4fd33d002f3-2000x759.jpg?q=50&w=416&h=158&format=auto`}
                        alt="Take a Virtual Tour"
                        loading="lazy"
                      />
                    ) : (
                      ``
                    )}
                  </a>
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default VisitMenu;
